/* eslint-disable import/prefer-default-export */
import {
  ISO_DATE_FORMAT, CORE_SEATS_UPPER_MAX, CORE_SEATS_LOWER_MIN, CORE_SEATS_DEFAULT,
} from '../constants/resyCore';

const isValidISODate = (dateItem) => moment(dateItem, ISO_DATE_FORMAT, true).isValid();

const isNotInThePast = (dateItem) => {
  const today = moment().format(ISO_DATE_FORMAT);
  return moment(dateItem, ISO_DATE_FORMAT).isSameOrAfter(today, 'day');
};

const isInFuture = (dateItem, timezone) => {
  if (timezone) {
    // Convert the current dateTime and the argument dateItem to the same timezone
    return moment().tz(timezone).isBefore(moment.tz(dateItem, timezone));
  }
  return moment().isBefore(dateItem);
};

const isInPast = (dateItem) => {
  const today = moment().format(ISO_DATE_FORMAT);
  return moment(dateItem, ISO_DATE_FORMAT).isSameOrBefore(today, 'day');
};

const isInteger = (num) => !Number.isNaN(num) && Number.isInteger(num);

const isConformingCoreISODate = (dateItem) => !!dateItem && isValidISODate(dateItem) && isNotInThePast(dateItem);

const isConformingCoreSeats = (seatsItem, min, max, isLargeParty = false) => {
  const allowedMax = isLargeParty ? max + 1 : max;
  return isInteger(seatsItem) && seatsItem >= min && seatsItem <= allowedMax;
};

const isConformingCoreSeatsMax = (maxItem) => isInteger(maxItem) && maxItem <= CORE_SEATS_UPPER_MAX;

const isConformingCoreSeatsMin = (minItem) => isInteger(minItem) && minItem >= CORE_SEATS_LOWER_MIN;

const getConformingCoreSeats = (coreSeats, coreSeatsMin, coreSeatsMax) => {
  let result;
  const seatsInteger = Number.parseInt(coreSeats, 10);
  if (isConformingCoreSeats(seatsInteger, coreSeatsMin, coreSeatsMax)) {
    result = seatsInteger;
  } else if (isConformingCoreSeats(CORE_SEATS_DEFAULT, coreSeatsMin, coreSeatsMax)) {
    result = CORE_SEATS_DEFAULT;
  } else {
    result = coreSeatsMin;
  }
  return result;
};

const isConformingCoreTime = (timeItem) => !!timeItem && /^[0-9]{4}$/.test(timeItem);

// eslint-disable-next-line eqeqeq
const shouldCoreParamUpdate = (existingValue, newValue) => existingValue != newValue;

export {
  getConformingCoreSeats, isConformingCoreISODate, isConformingCoreSeats, isConformingCoreSeatsMax, isConformingCoreSeatsMin, isConformingCoreTime, shouldCoreParamUpdate, isInFuture, isNotInThePast, isInPast,
};
